import { LightShowSegment } from './lightshow-segment';
import { LightShowOperation } from '../Operations/lightshow-operation';
import { SetColorOperation } from '../Operations/set-color-operation';
import { FlashTypes } from '../operation-types';

export class ToggleSolidColorSegment extends LightShowSegment {
  static fadeInDuration = 200;
  public colors: string[];

  public init() {
    this.color = 'blue';
    this.minDuration = ToggleSolidColorSegment.fadeInDuration;
    this.enableSegmentGrips = true;
  }

  public addOperations(operations: LightShowOperation[]) {
    const t1 = this.duration;
    const t2 = this.fadeIn;
    const t3 = this.fadeOut;

    operations.push(new SetColorOperation(this.position, this.fadeIn, this.colors[0], this.duration, this.fadeOut));

    operations.push(new SetColorOperation(this.position + this.duration - this.fadeOut, this.fadeOut, '#000000', 0, 0));

  }
}
